// Bu bileşen artık FloatingChat.jsx tarafından yönetiliyor.
// Jivo widget'ının kendi iframe'i FloatingChat içinde açılıp kapatılıyor.
export default function JivoChatGate() { return null; }
